/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './queryRules.defs.js'
export * as $defs from './queryRules.defs.js'
